import styled from 'styled-components';
import PanelWithHelp from '../PanelWithHelp';

export const ContentPaper = styled(PanelWithHelp)`
    padding: 16px;
`;

export const ContentHeader = styled.h2`
    margin-top: 0;
`;
